import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../button/button.jsx';

import styles from './publish-button.css';

const PublishButton = ({
    btnText,
    className,
    onClick
}) => (
    <Button
        className={classNames(
            className,
            styles.publishButton
        )}
        onClick={onClick}
    >
		<div className={classNames(
            className,
            styles.publishAction
        )}>{btnText}</div>
    </Button>
);

PublishButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func
};

PublishButton.defaultProps = {
    onClick: () => {}
};

export default PublishButton;
